(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-collection-header"] && !Shopify.designMode) return;
  try {
    /* Delegated, so it survives the theme re-rendering the section on filter changes */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.jh-cat-toggle');
    if (toggle) {
      document.documentElement.dataset.jhCols = toggle.dataset.cols;
      return;
    }
    if (e.target.closest('.jh-cat-header__filter')) {
      var drawer = document.getElementById('filters-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
    }
  });

  /* Mobile header tabs scroller: arrows + fades (delegated, so it survives section re-renders) */
  (function () {
    var NAVS = '.jh-cat-tabs, .jh-cat-sticky-tabs';
    var WRAPS = '.jh-cat-tabs-wrap, .jh-cat-sticky-wrap';

    function update(nav) {
      var wrap = nav.closest(WRAPS);
      if (!wrap) return;
      var max = nav.scrollWidth - nav.clientWidth;
      wrap.querySelector('.jh-cat-fade--prev').classList.toggle('is-visible', nav.scrollLeft > 2);
      wrap.querySelector('.jh-cat-fade--next').classList.toggle('is-visible', nav.scrollLeft < max - 2);
    }

    function centerActive(nav) {
      var active = nav.querySelector('.is-active');
      if (!active || nav.scrollWidth <= nav.clientWidth) return;
      nav.style.scrollBehavior = 'auto';
      nav.scrollLeft = active.offsetLeft - (nav.clientWidth - active.offsetWidth) / 2;
      nav.style.scrollBehavior = '';
    }

    function init() {
      document.querySelectorAll(NAVS).forEach(function (nav) {
        centerActive(nav);
        update(nav);
      });
    }

    document.addEventListener(
      'scroll',
      function (e) {
        var t = e.target;
        if (t.classList && (t.classList.contains('jh-cat-tabs') || t.classList.contains('jh-cat-sticky-tabs')))
          update(t);
      },
      { capture: true, passive: true }
    );

    window.addEventListener('resize', function () {
      document.querySelectorAll(NAVS).forEach(update);
    });
    window.addEventListener('load', init);
    document.addEventListener('shopify:section:load', init);
    init();
    setTimeout(init, 400);
  })();
  /* Sticky detection: flag lives on <html> so the section re-render can't wipe it */
  (function () {
    var ticking = false;

    function update() {
      ticking = false;
      var bar = document.querySelector('.jh-cat-bar');
      var stuck = false;
      if (bar) {
        var top = parseFloat(getComputedStyle(bar).top) || 0;
        stuck = bar.getBoundingClientRect().top <= top + 1;
      }
      document.documentElement.toggleAttribute('data-jh-stuck', stuck);
    }

    function schedule() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    /* Capture phase: scroll doesn't bubble, so this catches .page-wrapper (desktop) and the window (mobile) */
    document.addEventListener('scroll', schedule, { capture: true, passive: true });
    window.addEventListener('resize', schedule);
    document.addEventListener('shopify:section:load', schedule);
    schedule();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* ---------- Align product titles across a row ---------- */
  (function () {
    var timer;

    function alignTitles() {
      var titles = document.querySelectorAll('product-card [role="heading"]');

      titles.forEach(function (t) {
        t.style.minHeight = '';
      });

      var rows = {};
      titles.forEach(function (t) {
        var card = t.closest('product-card');
        if (!card) return;
        var top = Math.round(card.getBoundingClientRect().top + window.scrollY);
        (rows[top] = rows[top] || []).push(t);
      });

      Object.keys(rows).forEach(function (key) {
        var max = 0;
        rows[key].forEach(function (t) {
          max = Math.max(max, t.getBoundingClientRect().height);
        });
        rows[key].forEach(function (t) {
          t.style.minHeight = max + 'px';
        });
      });
    }

    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(alignTitles, 100);
    }

    document.addEventListener('DOMContentLoaded', schedule);
    window.addEventListener('load', schedule);
    window.addEventListener('resize', schedule);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
var grid = document.querySelector('results-list');
if (grid) new MutationObserver(schedule).observe(grid, { childList: true, subtree: true });
    schedule();
  })();

/* ---------- Touch: ignore the theme's hover image swap so one tap opens the product ---------- */
document.addEventListener(
  'pointerenter',
  function (event) {
    if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
    if (!(event.target instanceof Element) || !event.target.closest('product-card')) return;
    event.stopImmediatePropagation();
  },
  true
);

/* ---------- Touch: go back to the primary image when tapping elsewhere ---------- */
(function () {
  function reset(except) {
    document.querySelectorAll('product-card').forEach(function (card) {
      if (card === except) return;
      var s = card.refs && card.refs.slideshow;
      if (!s || s.current === 0) return;
      if (card.resetVariant && card.resetVariant.cancel) card.resetVariant.cancel();
      var picked = card.variantPicker && card.variantPicker.selectedOption;
      var id = picked && picked.dataset.optionMediaId;
      if (id) s.select({ id: id }, undefined, { animate: false });
      else s.select(0, undefined, { animate: false });
    });
  }

  window.addEventListener('pointerdown', function (event) {
    if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
    var t = event.target;
    if (!(t instanceof Element)) return;
    var gallery = t.closest('.card-gallery');
    var tapped = gallery ? gallery.closest('product-card') : null;
    reset(tapped);
    setTimeout(function () { reset(tapped); }, 50);
  }, true);
})();

  /* ---------- Clicks on a product card:
       image + title -> product page, swatch -> product page with that colour,
       "+" and other buttons -> unchanged, everything else -> nothing ---------- */
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      var card = target.closest('product-card');
      if (!card) return;

      /* "+" quick view */
      if (target.closest('.jh-qv-plus, quick-add-component')) return;

      /* Colour swatch: open the product with that colour */
      var swatchEl = target.closest('.variant-option__button-label--has-swatch, .variant-option__swatch');
      var swatch = null;
      if (swatchEl) {
        var box = (swatchEl.querySelector('.swatch') || swatchEl).getBoundingClientRect();
        var inside = event.clientX >= box.left - 4 && event.clientX <= box.right + 4 &&
                     event.clientY >= box.top - 4 && event.clientY <= box.bottom + 4;
        if (inside) swatch = swatchEl;
      }
      if (swatch) {
        event.preventDefault();
        event.stopPropagation();
        if (window.__jhSwatchNav) return;
        window.__jhSwatchNav = true;
        setTimeout(function () { window.__jhSwatchNav = false; }, 400);

        var input = swatch.querySelector('input');
        var variantId = input && (input.dataset.firstAvailableOrFirstVariantId || input.dataset.variantId);
        var anchor = card.querySelector('.product-card__link');
        var base = (anchor && anchor.getAttribute('href')) || (card.productPageUrl || '');
        if (!base) return;

        var url = new URL(base, window.location.origin);
        if (input && input.dataset.connectedProductUrl) {
          try { url.pathname = new URL(input.dataset.connectedProductUrl, window.location.origin).pathname; } catch (e) {}
        }
        if (variantId) url.searchParams.set('variant', variantId);

        if (event.metaKey || event.ctrlKey || event.shiftKey) window.open(url.href, '_blank');
        else window.location.href = url.href;
        return;
      }

      /* Image and title keep the theme's behaviour */
      if (target.closest('.card-gallery, [role="heading"]')) return;

      /* Dead zones: a click inside the price or swatch row (but not on a swatch) does nothing.
         Checked by position, so it also works when the click falls through to the card. */
      var zones = card.querySelectorAll('product-price, product-swatches, swatches-variant-picker-component');
      for (var i = 0; i < zones.length; i++) {
        var z = zones[i].getBoundingClientRect();
        if (event.clientX >= z.left && event.clientX <= z.right &&
            event.clientY >= z.top && event.clientY <= z.bottom) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
      }
    },
    true
  );
  } catch(e) { console.error(e); }
})();

})();
